<template>
    <div class="controlSet">
        <div class="page-header">
            <page-header></page-header>
            <div class="option-select">
                <template>
                    <el-select class="charts-input" @change="changeOption('true')" v-model="option.sys_alias" placeholder="请选择">
                        <el-option v-for="item in sys_alias" :key="item.id" :label="item.label" :value="item.val">
                        </el-option>
                    </el-select>
                </template>
                <div class="charts-input">
                    <el-button :loading="loading" @click="changeOption(false)" type="primary">{{loading ? '正在加载' : '刷新数据'}}</el-button>
                </div>
            </div>
        </div>

        <div class="css-margin-top">
            <div class="box-card m-card" body-style="{min-height:'300px'}">
                <loading v-if="loading"></loading>
                <template v-else>

                    <div class="clearfix chars-header">
                        <span class="card-header-title">参数列表</span>
                        <span></span>
                    </div>
                    <!-- isMobile table -->
                    <div class="time-show">
                        {{timeShow}}
                    </div>
                    <div  class="card-body">
                        <div class="m-table">
                            <div class="m-table-li" v-for="(item,index) in tableData">
                                <div class="m-table-label">
                                    {{item.name}}
                                </div>
                                <div class="m-table-input">
                                    <div class="edit-input">
                                        <p >{{item.data}}</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </template>

            </div>

        </div>

    </div>
</template>

<script>
    import {mapState} from "vuex";
    import Lib from "../../lib/lib.js";

    import pageHeader from "../../components/tempControl/header";
    import loading from "../../components/common/loading";

    import _ from "lodash";

    export default {
        name: "autoVal",
        components: {
            pageHeader,
            loading
        },
        data() {
            return {
                isEdit: false,
                option: {
                    sys_alias: ""
                },
                test: "",
                loading: "",
                sys_alias: [],
                val: "",
                confData: [],
                options: [
                    {
                        label: "一号窑",
                        val: 1
                    }
                ],
                tableData: [],
                timeShow: "",
                id_of_setinterval:''
            };
        },
        computed: mapState({
            isMobile: state => state.isMobile,
            deviceInfo: state => state.deviceInfo,
            userInfo: state => state.userInfo,
            config:state=>state.config
        }),
        created() {
            this.creatAliasMeun(this.deviceInfo.alias_m);
            this.option.sys_alias = "1";
        },
        mounted() {
            for (let i = 0; i < 1; i++) {
                this.checkUpdata();
                Lib.M.selectInputFoc();
            }
            this.timingLoad('OPEN')
        },
        beforeDestroy() {
            this.loading = false;
            this.timingLoad('CLOSE')
        },
        methods: {
            /**
             * 创建窑号选框
             * @argument MaxAlias 最大窑数
             */
            creatAliasMeun(MaxAlias) {
                for (let i = 0; i < MaxAlias; i++) {
                    this.sys_alias.push({
                        val: `${i + 1}`,
                        label: `${i + 1}号窑`
                    });
                }
            },
            // 检测缓存 没有或超时更新数据
            checkUpdata() {
                let isNew, date;
                this.changeOption(true);
            },
            changeOption(type){
                this.loading = true;
                this.confData = [];
                this.loadControlConf(type);
            },
            timingLoad(type){
                    if (type === "OPEN") {
                        this.id_of_setinterval = setInterval(() => {
                            this.loadControlConf(false);
                        }, this.config.refreshInterval?this.config.refreshInterval:30000);
                    } else {
                        clearInterval(this.id_of_setinterval);
                    }
            },
            loadControlConf(is_cache) {

                let params = {
                    conf_type: "auto",
                    sys_alias: this.option.sys_alias,
                    device_id: this.deviceInfo.device_id,
                    is_cache: is_cache
                };
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                Lib.api.loadDeviceConf(params, data => {
                    this.loading = false;
                    if (data.status_code === "SUCCEEDED") {
                    } else {
                        this.$message({
                            message: "获取自控变量错误," + data.msg,
                            type: "warning"
                        });
                    }
                    this.timeShow = data.payload.time_stamp;
                    if (data.payload && data.payload.data) {
                        let tableData = JSON.parse(data.payload.data);
                        if (tableData.oother) {
                            delete tableData.oother;
                            if (tableData.msg) {
                                delete tableData.msg;
                                delete tableData.isSuccess;
                            }
                        }
                        this.tableData = [];
                        for (var key in tableData) {
                            if (tableData.hasOwnProperty(key)) {
                                var element = tableData[key];
                                if (key !== "isSuccess" && key !== "msg") {
                                    this.tableData.push({
                                        name: key,
                                        data: element
                                    });
                                }
                            }
                        }
                    } else if (is_cache) {
                        this.loadControlConf(false);
                    }
                });
            }
        }
    };
</script>

<style scoped>
    .body-style {
        min-height: 300px;
    }

    .set-option {
        display: flex;
        justify-content: space-between;
    }
    .el-card box-card {
        width: 100%;
    }

    .chars-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }


    .table-list .el-table__header-wrapper thead div {
        background: #71b7ff;
    }



</style>




// WEBPACK FOOTER //
// autoVal.vue?bf8263ca